/*************************************************/
/* Vue                                           */
/*************************************************/

import { createApp, h } from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import FilteringComponent from './vue/filteringComponent.vue';


const filteringComponentAppSelector = "#filteringComponentApp";
if (document.querySelector(filteringComponentAppSelector) != null) {
    const filteringComponentNodeIds = document.querySelector(filteringComponentAppSelector).dataset.filteringComponentNodeIds;
    const pageSize = document.querySelector(filteringComponentAppSelector).dataset.pagesize;
    const showTags = document.querySelector(filteringComponentAppSelector).dataset.showTags;

    const preFilterIndustry = document.querySelector(filteringComponentAppSelector).dataset.prefilterIndustry;
    const preFilterSolution = document.querySelector(filteringComponentAppSelector).dataset.prefilterSolution;
    const preFilterType = document.querySelector(filteringComponentAppSelector).dataset.prefilterType;

    if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search);
        if (preFilterIndustry) {
            searchParams.set("industryTag", preFilterIndustry);
        }
        if (preFilterSolution) {
            searchParams.set("solutionTag", preFilterSolution);
        }
        if (preFilterType) {
            searchParams.set("typeTag", preFilterType);
        }
        window.history.replaceState({}, "title", window.location.origin + window.location.pathname + "?" + searchParams.toString());
    }

    const router = createRouter({
        history: createWebHistory(),
        routes: [{ path: window.location.pathname, component: FilteringComponent }]
    });

    const seedData = { filteringComponentNodeIds: filteringComponentNodeIds, pageSize: pageSize, showTags: showTags, preFilterIndustry: preFilterIndustry, preFilterSolution: preFilterSolution, preFilterType: preFilterType };

    const filteringComponentApp = createApp({
        data() { return seedData },
        render: () => h(FilteringComponent)
    }, seedData);

    filteringComponentApp.use(router);
    router.isReady().then(() => filteringComponentApp.mount(filteringComponentAppSelector));
}